import { AckMsg } from './../../protobuf/ack';
import msgBiz from './msgBiz';
import { MsgUtil } from './../../utils/index';
import PackageStore from './packageStore';
import AckStore from './ackStore';
export default class MsgParser {
    static processMsg(clientStater, pacakge) {
        PackageStore.createOrUpdate(pacakge);
        let msg = []; //存放解码后的消息
        let arr = []; //消息数组
        if (pacakge.msg.length > 0) {
            arr = pacakge.msg;
        }
        // 遍历数组-解码
        arr.forEach((value) => {
            let content = value;
            msg.push(content);
        });
        if (clientStater.opts.onmsg) {
            clientStater.opts.onmsg({ code: 200, data: MsgUtil.repeatMsg(msg) });
        }
    }
    static processAck(clientStater, ack) {
        AckStore.createOrUpdate(ack);
        switch (ack.ackState) {
            case AckMsg.MsgAckType.SERVER_WILL_FORWARD: { //服务端准备转发
                msgBiz.sendAck(clientStater, ack.guid, ack.fromGuid, ack.targetGuid, ack.guid, AckMsg.MsgAckType.CLIENT_TO_FORWARD);
                let _ack = msgBiz.buildAck(ack.guid, ack.fromGuid, ack.targetGuid, ack.guid, AckMsg.MsgAckType.CLIENT_TO_FORWARD);
                setTimeout(() => {
                    msgBiz.retryAck(clientStater, _ack, 3);
                }, 5000);
                break;
            }
            case AckMsg.MsgAckType.SERVER_FORWARD_OK:
                //todo 这里还得确认消息是否收到
                if (!PackageStore.contain(ack.refGuid)) {
                    //请求。拉取临时消息
                    msgBiz.getMsgBuffer(clientStater, ack.fromGuid)
                        .then(() => {
                            msgBiz.sendAck(clientStater, ack.guid, ack.fromGuid, ack.targetGuid, ack.refGuid, AckMsg.MsgAckType.CLIENT_RECEIVE);
                            //PackageStore.remove(ack.refGuid);
                        }).catch((e) => { console.log(e); })
                }
                else {
                    msgBiz.sendAck(clientStater, ack.guid, ack.fromGuid, ack.targetGuid, ack.refGuid, AckMsg.MsgAckType.CLIENT_RECEIVE);
                    PackageStore.remove(ack.refGuid);
                }
                break;
            case AckMsg.MsgAckType.FORWARD_OK:
                clientStater.dispatch(ack.guid, { code: 200, data: ack });
                break;
            case AckMsg.MsgAckType.CLIENT_SEND_FAIL:
                clientStater.dispatch(ack.guid, { code: 500, data: ack });
                break;
            default:
                // 移除多余的分号
                break;
        }
    }
}